import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useStore } from '@nuxtjs/composition-api';
import { State } from '~/store';

interface Props {
  item: {
    name: string;
    link: string;
    icon: string;
    type: string;
    subdomain?: boolean;
    description?: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationDropdownItemWithIcon',
  props: {
    item: null
  },
  emits: ["click"],
  setup(__props: any) {

const { $config } = useContext();
const store = useStore<State>();

const deviceId = computed(() => store.getters.deviceId);



return { __sfc: true,$config, store, deviceId }
}

})